<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <!-- 选择客户 -->
          <div class="tool">
            <h4>选择客户</h4>
            <div class="search">
              <el-select
                v-model="customerValue"
                placeholder="请选择客户"
                @change="customerChange"
                :loading="customerLoading"
                filterable>
                <el-option
                  v-for="item in customerData"
                  :key="item.client_id"
                  :label="item.number + ' ' + item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 页面标题 -->
          <div class="part">
            <div class="page_header">
              <i class="el-icon-picture-outline header_icon"></i>
              <h3>平面图转彩平</h3>
            </div>
          </div>

          <!-- 上传平面图 -->
          <div class="part">
            <h5>上传平面图</h5>
            <div class="upload_area">
              <el-upload
                v-if="!uploadedFloorplan"
                class="upload_dragger"
                drag
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleFloorplanUpload"
                accept="image/*">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持 JPG、PNG 格式图片</div>
              </el-upload>
              <div v-else class="preview_area">
                <img :src="uploadedFloorplan" alt="预览图">
                <el-button type="danger" size="small" class="clear_btn" @click="clearFloorplan">
                  <i class="el-icon-delete"></i> 清除
                </el-button>
              </div>
            </div>
          </div>

          <!-- 选择风格 -->
          <div class="part">
            <div class="style_header">
              <h5>选择风格</h5>
              <span class="hint">（可多选）</span>
            </div>
            <div class="style_options">
              <div
                v-for="style in styles"
                :key="style.id"
                :class="['style_item', { 'selected': isStyleSelected(style.id), 'full_width': style.id === 'custom' }]"
                @click="toggleStyle(style.id)">
                <el-checkbox
                  :value="isStyleSelected(style.id)"
                  @change="toggleStyle(style.id)">
                </el-checkbox>
                <div class="style_info">
                  <span class="style_name">{{ style.name }}</span>
                </div>
              </div>
            </div>

            <!-- 自定义风格描述 -->
            <div v-if="isCustomSelected" class="custom_style_input">
              <h5>自定义风格描述</h5>
              <el-input
                v-model="customStyle"
                placeholder="描述您想要的风格..."
                clearable>
              </el-input>
            </div>
          </div>

          <!-- 生成信息卡片 -->
          <div class="info_card">
            <div class="info_row">
              <span class="info_label">生成数量</span>
              <span class="info_value">{{ generationCount }} 张</span>
            </div>
            <div class="info_hint">
              已选择 {{ selectedStyles.length }} 个风格，每个风格生成 1 张效果图
            </div>
          </div>

          <!-- 生成按钮 -->
          <div class="btn_save">
            <el-button
              type="success"
              :loading="isGenerating"
              @click="handleGenerate"
              :disabled="!uploadedFloorplan || !customerValue"
              style="width:100%;">
              {{ isGenerating ? '生成中...' : '立即生成' }}
            </el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>

          <!-- 生成结果 -->
          <div class="part" v-if="generatedImages.length > 0">
            <h5>生成记录</h5>
            <div class="result_grid">
              <div
                v-for="(img, index) in generatedImages"
                :key="'result'+index"
                class="result_item">
                <!-- 生成中状态 -->
                <div v-if="img.status === 'pending'" class="result_loading">
                  <i class="el-icon-loading"></i>
                  <span>{{ img.style }} 生成中...</span>
                </div>
                <!-- 生成失败状态 -->
                <div v-else-if="img.status === 'error'" class="result_error">
                  <i class="el-icon-warning"></i>
                  <span>{{ img.style }} 生成失败</span>
                </div>
                <!-- 生成完成状态 -->
                <template v-else>
                  <img :src="img.url" alt="" class="result_image" @click="previewImage(img.url)">
                  <div class="result_info">
                    <p class="result_title">{{ img.style }}</p>
                    <div class="result_actions">
                      <el-button size="mini" type="success" plain @click="handleCollect(img)">收藏</el-button>
                      <el-button size="mini" type="success" plain @click="handleDownload(img)">下载</el-button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- 优质示例展示 -->
          <div class="example_section" v-if="exampleList.length > 0">
            <div class="example_header">
              <h5>优质案例</h5>
            </div>
            <div class="example_grid">
              <div
                v-for="item in exampleList"
                :key="'example'+item.id"
                class="example_item"
                @click="previewExample(item)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
              </div>
            </div>
          </div>
        </div>

        <!-- 图片预览弹窗 -->
        <el-dialog
          :visible.sync="previewVisible"
          width="auto"
          :close-on-click-modal="true"
          custom-class="image-preview-dialog"
          :modal-append-to-body="true"
          :append-to-body="true">
          <img :src="previewImageUrl" class="preview-dialog-image">
        </el-dialog>

        <!-- 示例详情弹窗 -->
        <el-dialog
          title="示例详情"
          :visible.sync="exampleDetailVisible"
          width="80%"
          top="5vh"
          :close-on-click-modal="true"
          custom-class="example-detail-dialog">
          <div class="example_detail" v-if="currentExample">
            <!-- 有原始图片时，横排显示两张图 -->
            <div v-if="currentExample.original_photo_url" class="detail_images_row">
              <div class="image_item">
                <p class="image_label">原始图片</p>
                <img :src="currentExample.original_photo_url" alt="原始图">
              </div>
              <div class="image_item">
                <p class="image_label">生成结果</p>
                <img :src="currentExample.photo_url" alt="生成结果">
              </div>
            </div>
            <!-- 只有一张图时，正常显示 -->
            <div v-else class="detail_single_layout">
              <div class="detail_left">
                <img :src="currentExample.photo_url" alt="">
              </div>
              <div class="detail_right">
                <div class="detail_item">
                  <label>提示词/描述：</label>
                  <p>{{ currentExample.description }}</p>
                </div>
                <div class="detail_item">
                  <label>使用模型：</label>
                  <p>{{ currentExample.model_name }}</p>
                </div>
                <div class="detail_item" v-if="currentExample.style_type">
                  <label>风格类型：</label>
                  <p>{{ currentExample.style_type }}</p>
                </div>
                <div class="detail_item" v-if="currentExample.space_type">
                  <label>空间类型：</label>
                  <p>{{ currentExample.space_type }}</p>
                </div>
                <div class="detail_actions">
                  <el-button type="success" @click="useThisExample">使用此提示词</el-button>
                </div>
              </div>
            </div>
            <!-- 有原始图片时，信息显示在下方 -->
            <div v-if="currentExample.original_photo_url" class="detail_info_bottom">
              <div class="detail_item">
                <label>提示词/描述：</label>
                <p>{{ currentExample.description }}</p>
              </div>
              <div class="detail_item">
                <label>使用模型：</label>
                <p>{{ currentExample.model_name }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.style_type">
                <label>风格类型：</label>
                <p>{{ currentExample.style_type }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.space_type">
                <label>空间类型：</label>
                <p>{{ currentExample.space_type }}</p>
              </div>
              <div class="detail_actions">
                <el-button type="success" @click="useThisExample">使用此提示词</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SideBarComponent from '@/components/SideBarComponent'
import SubTitleComponent from '@/components/SubTitleComponent'
import { apiDownload } from '@/utils/download'

export default {
  name: 'FloorplanToColor',
  components: {
    HeaderComponent,
    SideBarComponent,
    SubTitleComponent
  },
  data() {
    return {
      title: '平面图转彩平',
      customerData: [],
      customerValue: '',
      customerLoading: false,
      uploadedFloorplan: null,
      uploadedFloorplanUrl: '', // OSS上传后的URL
      selectedStyles: ['realistic'],
      customStyle: '',
      isGenerating: false,
      generatedImages: [],
      pollTimer: null,
      styles: [
        { id: 'realistic', name: '写实风格', desc: '真实照片般的渲染效果' },
        { id: 'sketch', name: '文本风格', desc: '文本标注形式展现' },
        { id: 'cream', name: '淡系奶油风格', desc: '柔和温暖的奶油色调' },
        { id: 'gray', name: '高级灰填充风格', desc: '简约高级的灰色调' },
        { id: 'custom', name: '自定义风格', desc: '自由定义风格参数' }
      ],
      previewVisible: false,
      previewImageUrl: '',
      // 示例展示相关
      exampleList: [],
      exampleDetailVisible: false,
      currentExample: null
    }
  },
  computed: {
    isCustomSelected() {
      return this.selectedStyles.includes('custom')
    },
    generationCount() {
      return this.selectedStyles.length
    }
  },
  created() {
    this.getCustomerList()
    this.getExampleList()
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.customerLoading = true
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        let _data = json.data.data
        if (json.data.errcode === 0) {
          this.customerData = _data.result
          // 自动选择逻辑
          if (this.global.type === 'client' && this.global.clientId) {
            this.customerValue = parseInt(this.global.clientId)
          } else if (this.customerData.length === 1) {
            this.customerValue = this.customerData[0].client_id
          } else if (this.global.type === 'manage' && this.global.clientName) {
            const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
            if (rememberedClient) {
              this.customerValue = rememberedClient.client_id
            }
          } else if (this.customerData.length > 0 && !this.customerValue) {
            this.customerValue = this.customerData[0].client_id
          }
        } else {
          this.$message.error(json.data.error || '获取客户列表失败')
        }
      }).catch(() => {
        this.$message.error('网络错误，无法获取客户列表')
      }).finally(() => {
        this.customerLoading = false
      })
    },
    // 客户选择变化
    customerChange(val) {
      const selectedCustomer = this.customerData.find(c => c.client_id === val)
      if (selectedCustomer) {
        this.global.clientId = selectedCustomer.client_id
        this.global.clientName = selectedCustomer.client_name
      }
    },
    // 处理平面图上传
    handleFloorplanUpload(file) {
      const isImage = file.raw.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }
      // 显示预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedFloorplan = e.target.result
      }
      reader.readAsDataURL(file.raw)
      // OSS直传
      this.uploadToOSS(file.raw)
    },
    // OSS直传
    uploadToOSS(file) {
      var self = this
      const loading = this.$loading({
        lock: true,
        text: '正在上传图片...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 1. 获取OSS签名
      let _url = "/api/?mod=oss&action=signature"
      self.axios.post(_url).then(function(json) {
        if (json.data.errcode !== 0) {
          self.$message.error(json.data.error || '获取签名失败')
          loading.close()
          return
        }

        var ossData = json.data.data
        var timestamp = Date.now()
        var random = Math.floor(Math.random() * 10000)
        var fileExt = file.name.split('.').pop()
        var fileName = timestamp + '' + random + '.' + fileExt
        var key = ossData.dir + fileName

        // 2. 构造FormData上传到OSS
        var formData = new FormData()
        formData.append('key', key)
        formData.append('policy', ossData.policy)
        formData.append('OSSAccessKeyId', ossData.accessid)
        formData.append('signature', ossData.signature)
        formData.append('success_action_status', '200')
        formData.append('file', file)

        // 3. 直接上传到OSS
        self.axios.post(ossData.host, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [function(data, headers) {
            delete headers.Authorization
            return data
          }],
          // OSS返回空字符串，明确告诉axios这是成功的响应
          validateStatus: function(status) {
            return status === 200
          }
        }).then(function(response) {
          // 上传成功，保存URL
          self.uploadedFloorplanUrl = ossData.host + '/' + key
          self.$message.success('图片上传成功')
          loading.close()
        }).catch(function() {
          self.$message.error('图片上传失败')
          self.uploadedFloorplan = null
          loading.close()
        })
      }).catch(function() {
        self.$message.error('网络错误')
        loading.close()
      })
    },
    // 清除平面图
    clearFloorplan() {
      this.uploadedFloorplan = null
      this.uploadedFloorplanUrl = ''
    },
    // 判断风格是否被选中
    isStyleSelected(styleId) {
      return this.selectedStyles.includes(styleId)
    },
    // 切换风格选择
    toggleStyle(styleId) {
      const index = this.selectedStyles.indexOf(styleId)
      if (index > -1) {
        // 至少保留一个风格
        if (this.selectedStyles.length === 1) return
        this.selectedStyles.splice(index, 1)
      } else {
        this.selectedStyles.push(styleId)
      }
    },
    // 生成彩平图
    handleGenerate() {
      if (!this.uploadedFloorplan) {
        this.$message.warning('请先上传平面图')
        return
      }
      if (!this.uploadedFloorplanUrl) {
        this.$message.warning('图片正在上传中，请稍候')
        return
      }
      if (!this.customerValue) {
        this.$message.warning('请选择客户')
        return
      }
      if (this.selectedStyles.length === 0) {
        this.$message.warning('请至少选择一个风格')
        return
      }
      if (this.isCustomSelected && !this.customStyle) {
        this.$message.warning('请输入自定义风格描述')
        return
      }

      this.isGenerating = true
      this.generatedImages = []

      // 每个风格单独调用一次接口
      const requests = this.selectedStyles.map(style => {
        const params = {
          client_id: this.customerValue,
          floorplan_url: this.uploadedFloorplanUrl,
          style: style,
          custom_style: style === 'custom' ? this.customStyle : '',
          count: 1
        }
        let _url = "/api/?mod=effect&action=save-floorplan"
        return this.axios.post(_url, params)
      })

      // 等待所有请求完成
      Promise.all(requests).then(results => {
        const effectIds = []
        results.forEach((json, index) => {
          if (json.data.errcode === 0 && json.data.data.effect_id) {
            const style = this.styles.find(s => s.id === this.selectedStyles[index])
            const styleName = style ? style.name : ''
            this.generatedImages.push({
              effect_id: json.data.data.effect_id,
              style: styleName,
              status: 'pending',
              url: ''
            })
            effectIds.push(json.data.data.effect_id)
          }
        })
        if (effectIds.length > 0) {
          this.$message.success('已提交生成任务，正在生成中...')
          this.startPolling()
        } else {
          this.$message.error('生成任务提交失败')
          this.isGenerating = false
        }
      }).catch(() => {
        this.$message.error('网络错误，请重试')
        this.isGenerating = false
      })
    },
    // 开始轮询结果
    startPolling() {
      const poll = () => {
        const pendingImages = this.generatedImages.filter(img => img.status === 'pending')
        if (pendingImages.length === 0) {
          this.isGenerating = false
          this.$message.success('生成完成！')
          return
        }

        // 查询每个待处理任务的状态
        pendingImages.forEach(img => {
          let _url = "/api/?mod=effect&action=result"
          this.axios.post(_url, { effect_id: img.effect_id }).then(json => {
            if (json.data.errcode === 0) {
              const result = json.data.data
              const index = this.generatedImages.findIndex(i => i.effect_id === img.effect_id)
              if (index > -1) {
                if (result.status === 1 && result.result && result.result.length > 0) {
                  // 生成成功
                  this.generatedImages[index].status = 'completed'
                  this.generatedImages[index].url = result.result[0].file_url
                } else if (result.status === 2) {
                  // 生成失败
                  this.generatedImages[index].status = 'error'
                }
              }
            }
          })
        })

        // 继续轮询
        this.pollTimer = setTimeout(poll, 2000)
      }

      // 立即执行第一次轮询
      poll()
    },
    // 收藏
    handleCollect(img) {
      this.$message.success('收藏成功')
    },
    // 下载
    handleDownload(img) {
      let _href = ''
      let _imgUrl = img.url
      // 处理OSS URL，转换为代理路径
      if (_imgUrl.startsWith('https://oss.ylw.s136.ailo.vip')) {
        _href = _imgUrl.replace('https://oss.ylw.s136.ailo.vip', '/ai_images')
      } else if (_imgUrl.startsWith('https://aigc.oss.ylwai.cn')) {
        _href = _imgUrl.replace('https://aigc.oss.ylwai.cn', '/ai2_images')
      } else {
        _href = _imgUrl
      }
      console.log('下载路径:', _href)
      apiDownload(_href)
    },
    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl
      this.previewVisible = true
    },
    // 获取示例列表
    getExampleList() {
      let _url = "/api/?mod=example&action=list"
      let _data = {
        type: 4,  // 4=平面转彩平
        pagesize: 10
      }
      this.axios.post(_url, _data).then(json => {
        if (json.data.errcode === 0) {
          this.exampleList = json.data.data.result || []
        }
      }).catch(error => {
        console.error('获取示例列表失败:', error)
      })
    },
    // 预览示例详情
    previewExample(item) {
      this.currentExample = item
      this.exampleDetailVisible = true
    },
    // 使用此提示词
    useThisExample() {
      if (this.currentExample) {
        // 填充风格选择
        if (this.currentExample.style_type) {
          this.customStyle = this.currentExample.style_type
          if (!this.selectedStyles.includes('custom')) {
            this.selectedStyles.push('custom')
          }
        }
        this.exampleDetailVisible = false
        this.$message.success('已应用示例配置')
      }
    }
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  background: #f5f5f5;
  padding: 10px;
  .box {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    .tool {
      margin-bottom: 20px;
      h4 {
        margin-bottom: 10px;
        font-size: 16px;
        color: #333;
      }
      .search {
        /deep/ .el-select {
          width: 300px;
        }
      }
    }
    .part {
      margin-bottom: 20px;
      h5 {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
      }
      .page_header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        .header_icon {
          font-size: 24px;
          color: #50b85c;
        }
        h3 {
          font-size: 18px;
          color: #333;
          margin: 0;
        }
      }
      .style_header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        h5 {
          margin: 0;
        }
        .hint {
          font-size: 12px;
          color: #999;
        }
      }
      .style_options {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        .style_item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 16px;
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          box-sizing: border-box;
          &:hover {
            border-color: #c0c4cc;
          }
          &.selected {
            border-color: #50b85c;
            background: #f0f9f0;
          }
          &.full_width {
            grid-column: span 2;
          }
          .style_info {
            flex: 1;
            .style_name {
              font-size: 14px;
              font-weight: 500;
              color: #333;
            }
          }
        }
      }
      .custom_style_input {
        margin-top: 15px;
        h5 {
          margin-bottom: 8px;
        }
      }
    }
    .upload_area {
      .upload_dragger {
        width: 100%;
        /deep/ .el-upload {
          width: 100%;
        }
        /deep/ .el-upload-dragger {
          width: 100%;
          height: 200px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
      .preview_area {
        position: relative;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 10px;
        background: #fafafa;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 200px;
          object-fit: contain;
          border-radius: 4px;
        }
        .clear_btn {
          margin-top: 10px;
        }
      }
    }
    .info_card {
      padding: 16px;
      background: #f5f7fa;
      border-radius: 8px;
      margin-bottom: 20px;
      .info_row {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        .info_label {
          color: #666;
        }
        .info_value {
          color: #333;
          font-weight: 500;
        }
      }
      .info_hint {
        margin-top: 8px;
        font-size: 12px;
        color: #999;
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .result_grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
      .result_item {
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        overflow: hidden;
        .result_loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #409eff;
          font-size: 14px;
          i {
            font-size: 32px;
            margin-bottom: 10px;
          }
        }
        .result_error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #f56c6c;
          font-size: 14px;
          i {
            font-size: 32px;
            margin-bottom: 10px;
          }
        }
        .result_image {
          width: 100%;
          height: 200px;
          object-fit: cover;
          cursor: pointer;
          transition: opacity 0.3s;
          &:hover {
            opacity: 0.8;
          }
        }
        .result_info {
          padding: 12px;
          .result_title {
            font-size: 14px;
            color: #666;
            text-align: center;
            margin-bottom: 10px;
          }
          .result_actions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
        }
      }
    }
  }
}
// 图片预览弹窗样式
/deep/ .image-preview-dialog {
  background: transparent;
  box-shadow: none;
  margin: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .preview-dialog-image {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    display: block;
    border-radius: 8px;
  }
}
// 示例展示样式
.example_section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  .example_header {
    margin-bottom: 15px;
    h5 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
  }
  .example_grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    .example_item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }
      .example_info {
        padding: 10px;
        .example_title {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .example_desc {
          font-size: 12px;
          color: #666;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.4;
          height: 33.6px;
        }
        .example_model {
          font-size: 12px;
          color: #50b85c;
          margin-bottom: 8px;
        }
        .example_tags {
          .el-tag {
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
// 示例详情弹窗样式 - 使用深度选择器
::v-deep .example-detail-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff !important;

  .el-dialog__header {
    // background: linear-gradient(135deg, #ccc 0%, #ddd 100%) !important;
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;

    .el-dialog__title {
      color: #fff !important;
      font-size: 18px !important;
      font-weight: 600 !important;
    }

    .el-dialog__headerbtn {
      top: 20px !important;
      right: 20px !important;

      .el-dialog__close {
        color: #fff !important;
        font-size: 20px !important;

        &:hover {
          color: rgba(255, 255, 255, 0.8) !important;
        }
      }
    }
  }

  .el-dialog__body {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
    background: #fff !important;
    padding: 0 !important;
  }
}
.example_detail {
  padding: 20px;

  // 横排显示两张图片
  .detail_images_row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    .image_item {
      flex: 1;
      .image_label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
        font-weight: 500;
      }
      img {
        width: 100%;
        max-height: 60vh;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      }
    }
  }

  // 单图布局（左右结构）
  .detail_single_layout {
    display: flex;
    gap: 30px;
    .detail_left {
      flex: 1;
      img {
        width: 100%;
        max-height: 60vh;
        object-fit: contain;
        border-radius: 8px;
      }
    }
    .detail_right {
      flex: 1;
    }
  }

  // 信息显示在底部
  .detail_info_bottom {
    padding-top: 20px;
    border-top: 1px solid #eee;
  }

  // 详情项样式
  .detail_item {
    margin-bottom: 15px;
    label {
      display: block;
      font-size: 14px;
      color: #999;
      margin-bottom: 5px;
    }
    p {
      font-size: 14px;
      color: #333;
      line-height: 1.6;
    }
  }

  .detail_actions {
    margin-top: 30px;
  }
}
</style>

<style lang="less">
// 示例详情弹窗标题栏样式 - 非 scoped，使用更强的选择器确保能覆盖 Element UI 样式
.el-dialog__wrapper .example-detail-dialog.el-dialog {
  background: #fff !important;

  .el-dialog__header {
    // background: linear-gradient(135deg,  #ccc 0%, #ddd 100%) !important;
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;
  }

  .el-dialog__title {
    color: #fff !important;
    font-size: 18px !important;
    font-weight: 600 !important;
  }

  .el-dialog__headerbtn {
    top: 20px !important;
    right: 20px !important;
  }

  .el-dialog__close {
    color: #fff !important;
    font-size: 20px !important;

    &:hover {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }

  .el-dialog__body {
    background: #fff !important;
    padding: 0 !important;
  }
}

// 额外的强制样式，确保覆盖
.el-dialog.example-detail-dialog .el-dialog__header {
  background: linear-gradient(135deg, #f0f9ff 0%, #e8f5e9 100%) !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/views/FloorplanToColor/Index.vue